import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Checkbox = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="transparent" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke={color} />
    </svg>
  )
})

export default Checkbox
